var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-toolbar',{staticClass:"position-absolute"},[_c('p-toolbar-action',{attrs:{"icon":"mdi-map-marker","tooltip":_vm.defaultView
        ? `Save default view (${_vm.defaultView.position.x}, ${_vm.defaultView.position.y}, ${_vm.defaultView.position.z})`
        : 'Save default view'},on:{"click":_vm.saveCurrentView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }